// Reviews.tsx
import React, { useState } from "react";
import CommentListing from "components/CommentListing/CommentListing";
import ButtonPrimary from "shared/Button/ButtonPrimary";

interface ReviewsProps {
  reviews: {
    total: number;
    items: any[];
  };
}

const Reviews: React.FC<ReviewsProps> = ({ reviews }) => {

  const reviewArray = reviews.items;

  // Show first 6 reviews initially
  const [visibleReviews, setVisibleReviews] = useState(
    reviewArray?.slice(0, 6)
  );

  // Check if there are more reviews
  const [hasMoreReviews, setHasMoreReviews] = useState(reviews?.total > 3); 

  // Handle showing additional reviews
  function showAdditionalReviews() {
    const currentLength = visibleReviews.length;
    const totalReviews = reviews?.total || 0; // Total number of reviews

    // Calculate the number of reviews to show
    const remainingReviews = totalReviews - currentLength;
    const reviewsToShow = Math.min(3, remainingReviews); // Show up to 3, or the remaining reviews if fewer

    // Slice the reviews safely
    const nextReviews =
      reviews?.items?.slice(currentLength, currentLength + reviewsToShow) || [];
    setVisibleReviews([...visibleReviews, ...nextReviews]);

    // Update hasMoreReviews based on the new length
    if (currentLength + nextReviews.length >= totalReviews) {
      setHasMoreReviews(false); // No more reviews to show
    }
  }

  return (
    <div className="listingSection__wrap">
      {/* HEADING */}
      <h2 className="text-2xl font-semibold">
        Reviews ({reviews.total} reviews)
      </h2>
      {/* Comment Section */}
      <div className="divide-y divide-neutral-100 dark:divide-neutral-800">
        {visibleReviews?.map((review: any, index: number) => (
          <CommentListing key={index} review={review} className="py-8" />
        ))}
        {/* Show "More Reviews" button if there are more reviews to display */}
        {hasMoreReviews && (
          <div className="pt-8">
            <ButtonPrimary onClick={showAdditionalReviews}>
              Show More Reviews
            </ButtonPrimary>
          </div>
        )}
      </div>
    </div>
  );
};

export default Reviews;
